import { WithDataTestId } from '@mews-commander/types';
import { Link, LinkProps } from '@optimus-web/core';

const createPlainLinkClickHandler =
    (onClick: React.MouseEventHandler, href?: string): React.MouseEventHandler =>
    (event) => {
        if ((event.metaKey || event.ctrlKey) && href) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        onClick(event);
    };

export type OptimusPlainLinkProps = React.PropsWithChildren<LinkProps & Required<Pick<LinkProps, 'onClick'>>> &
    WithDataTestId;

/**
 * @deprecated Use `RouteLink` for internal links with a known RouteName
 */
export const OptimusPlainLink: React.FC<OptimusPlainLinkProps> = ({
    onClick,
    children,
    className,
    dataTestId,
    href,
    ...other
}) => {
    const handleClick = createPlainLinkClickHandler(onClick, href);

    return (
        <Link onClick={handleClick} className={className} data-test-id={dataTestId} href={href} {...other}>
            {children}
        </Link>
    );
};
